import { useSelector } from 'react-redux'

import { socialReturnOnInvestmentReportSelector } from '../../../modules/selectors/socialReturnOnInvestment'
import { COUNTRY_ID } from './forms/fields'

export const getSroiCurrencySymbol = countryOfOperation => {
  if (countryOfOperation === 'AUS') {
    // if country is Australia, return 'A$'
    return 'A$'
  } else if (countryOfOperation === 'SAU') {
    return 'SAR'
  } else if (countryOfOperation === 'GBR') {
    return '£'
  }
}

export const useSroiReportCurrencySymbol = () => {
  const { [COUNTRY_ID]: countryOfOperation } = useSelector(socialReturnOnInvestmentReportSelector)

  return getSroiCurrencySymbol(countryOfOperation)
}
